import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () => import('@/layouts/ExternalLayout'),
      children: [
        {
          name: 'Login',
          path: '/',
          component: () => import('@/views/pages/Login'),
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/layouts/DefaultLayout'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Maps
        {
          name: 'Search',
          path: 'search',
          component: () => import('@/views/search/Index'),
        },
        // Maps
        {
          name: 'Maps',
          path: 'maps',
          component: () => import('@/views/maps/Index'),
        },
        // Pages
        {
          name: 'Sites',
          path: 'sites',
          component: () => import('@/views/sites/Index'),
        },
        {
          name: 'Sectors',
          path: 'sectors',
          component: () => import('@/views/sectors/Index'),
        },
        {
          name: 'Cells',
          path: 'cells',
          component: () => import('@/views/cells/Index'),
        },
        {
          name: 'Radio acces',
          path: 'radio-access',
          component: () => import('@/views/radio-access/Index'),
        },
        {
          name: 'Sites',
          path: 'sites/:id/view',
          component: () => import('@/views/sites/View'),
        },
        {
          name: 'Sites',
          path: 'sites/:id/view/contract/:contractId',
          component: () => import('@/views/sites/View'),
        },
        {
          name: 'Sites',
          path: 'sites/:id/view/permit/:permitId',
          component: () => import('@/views/sites/View'),
        },
        {
          name: 'Sites',
          path: 'sites/:id/view/sector/:sectorId',
          component: () => import('@/views/sites/View'),
        },
        {
          name: 'Sites',
          path: 'sites/:id/view/sector/:sectorId/cell/:cellId',
          component: () => import('@/views/sites/View'),
        },
        {
          name: 'Code list',
          path: 'code-list/:key/',
          component: () => import('@/views/code-list/View'),
        },
        {
          name: 'Equipment battery',
          path: 'equipment/battery/',
          component: () => import('@/views/equipment/Battery'),
        },
        {
          name: 'Equipment shelter',
          path: 'equipment/shelter/',
          component: () => import('@/views/equipment/Shelter'),
        },
        {
          name: 'Equipment tower',
          path: 'equipment/tower/',
          component: () => import('@/views/equipment/Tower'),
        },
        {
          name: 'Equipment air conditioning',
          path: 'equipment/air-conditioning/',
          component: () => import('@/views/equipment/AirConditioning'),
        },
        {
          name: 'Equipment dc system',
          path: 'equipment/dc-system/',
          component: () => import('@/views/equipment/DcSystem'),
        },
        {
          name: 'Rollout',
          path: 'rollout/',
          component: () => import('@/views/rollout/Index'),
        },
        {
          name: 'Tenants',
          path: 'tenants/',
          component: () => import('@/views/tenants/Index'),
        },
        {
          name: 'Contracts',
          path: 'contract/',
          component: () => import('@/views/contract/Index'),
        },
        {
          name: 'Permit ministry of health',
          path: 'permits-ministry-health/',
          component: () => import('@/views/permit-ministry-health/PermitMinistryOfHealth'),
        },
        {
          name: 'Permission - Groups',
          path: 'permissions/groups/',
          component: () => import('@/views/permissions/Group'),
        },
        {
          name: 'Permission - Users',
          path: 'permissions/users/',
          component: () => import('@/views/permissions/User'),
        },
        // {
        //   name: 'User Profile',
        //   path: 'pages/user',
        //   component: () => import('@/views/dashboard/pages/UserProfile'),
        // },
        // {
        //   name: 'Timeline',
        //   path: 'pages/timeline',
        //   component: () => import('@/views/dashboard/pages/Timeline'),
        // },
        // // Components
        // {
        //   name: 'Buttons',
        //   path: 'components/buttons',
        //   component: () => import('@/views/dashboard/component/Buttons'),
        // },
        // {
        //   name: 'Grid System',
        //   path: 'components/grid-system',
        //   component: () => import('@/views/dashboard/component/Grid'),
        // },
        // {
        //   name: 'Tabs',
        //   path: 'components/tabs',
        //   component: () => import('@/views/dashboard/component/Tabs'),
        // },
        // {
        //   name: 'Notifications',
        //   path: 'components/notifications',
        //   component: () => import('@/views/dashboard/component/Notifications'),
        // },
        // {
        //   name: 'Icons',
        //   path: 'components/icons',
        //   component: () => import('@/views/dashboard/component/Icons'),
        // },
        // {
        //   name: 'Typography',
        //   path: 'components/typography',
        //   component: () => import('@/views/dashboard/component/Typography'),
        // },
        // // Forms
        // {
        //   name: 'Regular Forms',
        //   path: 'forms/regular',
        //   component: () => import('@/views/dashboard/forms/RegularForms'),
        // },
        // {
        //   name: 'Extended Forms',
        //   path: 'forms/extended',
        //   component: () => import('@/views/dashboard/forms/ExtendedForms'),
        // },
        // {
        //   name: 'Validation Forms',
        //   path: 'forms/validation',
        //   component: () => import('@/views/dashboard/forms/ValidationForms'),
        // },
        // {
        //   name: 'Wizard',
        //   path: 'forms/wizard',
        //   component: () => import('@/views/dashboard/forms/Wizard'),
        // },
        // // Tables
        // {
        //   name: 'Regular Tables',
        //   path: 'tables/regular-tables',
        //   component: () => import('@/views/dashboard/tables/RegularTables'),
        // },
        // {
        //   name: 'Extended Tables',
        //   path: 'tables/extended-tables',
        //   component: () => import('@/views/dashboard/tables/ExtendedTables'),
        // },
        // {
        //   name: 'Data Tabels',
        //   path: 'tables/data-tables',
        //   component: () => import('@/views/dashboard/tables/DataTables'),
        // },
        // // Maps
        // {
        //   name: 'Google Maps',
        //   path: 'maps/google-maps',
        //   component: () => import('@/views/dashboard/maps/GoogleMaps'),
        // },
        // {
        //   name: 'Full Screen Map',
        //   path: 'maps/full-screen-map',
        //   component: () => import('@/views/dashboard/maps/FullScreenMap'),
        // },
        // // Root level
        // {
        //   name: 'Widgets',
        //   path: 'widgets',
        //   component: () => import('@/views/dashboard/Widgets'),
        // },
        // {
        //   name: 'Charts',
        //   path: 'charts',
        //   component: () => import('@/views/dashboard/Charts'),
        // },
        // {
        //   name: 'Calendar',
        //   path: 'calendar',
        //   component: () => import('@/views/dashboard/Calendar'),
        // },
      ],
    },
  ],
})
